import ReactDOMServer from 'react-dom/server';

function exportTable(table, fileName){
  function getHTML(table, fileName){
    return (`
    <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel">
      <head>
        <!--[if gte mso 9]>
          <xml>
            <x:ExcelWorkbook>
                <x:ExcelWorksheets>
                  <x:ExcelWorksheet>
                      <x:Name>${fileName || 'Worksheet'}</x:Name>
                      <x:WorksheetOptions>
                        <x:DisplayGridlines/>
                        <x:FilterOn/>
                      </x:WorksheetOptions>
                  </x:ExcelWorksheet>
                </x:ExcelWorksheets>
            </x:ExcelWorkbook>
          </xml>
        <![endif]-->
        <meta name=ProgId content=Excel.Sheet>
        <meta name=Generator content="Microsoft Excel 9">
        <style>
          thead tr th{
            font-weight: bold;
          }
          .money{
            mso-number-format:"\\22R$\\22\\20#\,##0.00";
          }
          .date{
            mso-number-format:"Short Date";
            width:80px;
          }
        </style>
      </head>
      <body>
        ${table}
      </body>
    </html>`);
  }

  const dateDocument = new Intl.DateTimeFormat('pt-BR')
  .format(new Date())
  .replace(/\//g, '_');

  var data_type = 'data:application/vnd.ms-excel; charset=UTF-8';
  var a = document.createElement('a');

  var table_html = escape(getHTML(ReactDOMServer.renderToString(table), fileName));
  a.href = data_type + ', ' + table_html;
  a.download = `${fileName}_${dateDocument}.xls`;
  a.click();
}

export default exportTable;